<template>
  <span
    class="llm-edit-icon-btn"
    :class="`llm-edit-icon-btn--${size}`"
    :title="title"
    role="button"
    tabindex="0"
    v-on="$listeners"
  >
    <EditOutlinedIcon :size="iconSize" />
  </span>
</template>

<script>
import EditOutlinedIcon from './EditOutlinedIcon.vue'

const ICON_SIZE_MAP = {
  sm: 16,
  md: 16,
}

export default {
  name: 'EditIconButton',
  components: { EditOutlinedIcon },
  props: {
    title: {
      type: String,
      default: '编辑',
    },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md'].includes(v),
    },
  },
  computed: {
    iconSize() {
      return ICON_SIZE_MAP[this.size] || ICON_SIZE_MAP.md
    },
  },
}
</script>

<style scoped>
.llm-edit-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 4px;
  color: #909399;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  outline: none;
  vertical-align: middle;
  line-height: 1;
}

.llm-edit-icon-btn--sm {
  width: 20px;
  height: 20px;
}

.llm-edit-icon-btn--md {
  width: 32px;
  height: 32px;
}

.llm-edit-icon-btn:hover,
.llm-edit-icon-btn:focus-visible {
  background: #e8ecf4;
  color: #606266;
}
</style>
